import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CreateCampaignForm from './CreateCampaignForm';
import CreateCampaignSidebar from './CreateCampaignSidebar';
import { getTimezone } from '../../../helpers/helperFunction';
import { getRequest } from '../../../helpers/apiHandler'
import {
  refreshTemplates,
  updateRefreshTemplatesTime,
} from '../../../store/actions/reduxAction';
import CustomAlert from '../../../components/CustomAlert';
const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const CreateCampaign = () => {
  const dispatch = useDispatch();
  const { access_token, user } = useSelector((state) => state.auth);
  const { refreshTemplate, lastRefreshTemplate } = useSelector((state) => state.campaign);
  const location = useLocation();
  const { country, brand_name, verified } = user;

  let campaign_data = location.state?.campaign_data;

  const user_timezone = getTimezone().filter((x) => x.value === user.timezone);

  // schedule time will be parsed as local time format
  const schedule_time = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 19);

  const [campaign_form_fields, setCampaignFormFields] = useState({
    message_content: campaign_data?.message_content || "",
    campaign_name: campaign_data?.campaign_name || "",
    campaign_id: campaign_data?.id || null,
    contact_list: "",
    contact_options: [],
    selected_custom_field: campaign_data?.selected_custom_field || null,
    selected_contact_list: campaign_data?.selected_contact_list || '',
    template_options: [],
    selected_template: campaign_data?.selected_template || null,
    template_name: "",
    quick_sms_numbers: "",
    sms_count: 0,
    contact_type: campaign_data?.type === "SMS Campaign" ? "contacts" : "quick_sms",
    schedule_time: campaign_data?.schedule_time || schedule_time,
    timezone: user_timezone,
    message_count: 1,
    brand_name: white_label_perkeso ? "PERKESO" : brand_name,
    campaign_price: 0,
    user_rates: [],
    sms_price_list: [],
    custom_field_options: [],
  });

  const handleCampaignFormFieldsChange = (field, value) => {
    setCampaignFormFields((prevFields) => ({
      ...prevFields,
      [field]: value,
    }));
  };

  const [alertState, setAlertState] = useState({
    show: false,
    variant: '',
    message: '',
  });

  const getContactList = () => {
    const data = {
      headers: { Authorization: access_token?.token },
    };
    getRequest('/v2/contacts-list', data, (res) => {
      if (res.error) return;
      const { data } = res;

      const contact_options = data?.contact_list.map(item => {
        if (item.id === campaign_form_fields?.selected_contact_list?.id) {
          handleCampaignFormFieldsChange("custom_field_options", item.fields_list);
        }
        return ({
          value: item.id,
          label: `${item.name} (${item.count} contacts)`,
          count: item.count,
          fields: item.fields_list,
          id: item.id
        });
      });

      handleCampaignFormFieldsChange("contact_options", contact_options);

    });
  };

  const get_set_sms_price_list = () => {
    const data = { headers: { Authorization: access_token.token } };
    getRequest(`/payment/sms-price-list`, data, (res) => {
      if (res.success) {
        handleCampaignFormFieldsChange("sms_price_list", res.data);
      }
    });
  }

  const getTemplates = () => {

    const data = {
      headers: { Authorization: access_token?.token },
    };
    getRequest('/v2/template-all', data, (res) => {
      if (res.success) {
        const { data } = res;

        const template_options = data.map(item => ({ value: item.id, label: item.name, id: item.id, name: item.name, message_content: item.content }));

        handleCampaignFormFieldsChange("template_options", template_options);
      }
    });
  };

  useEffect(() => {
    getContactList();
    get_set_sms_price_list();
  }, [])

  useEffect(() => {
    if (refreshTemplate) {

      getTemplates();
      dispatch(refreshTemplates()); // Toggle it off
    }
  }, [refreshTemplate])

  /*
      Add when the refreshTemplate is false and the lastRefreshTemplate is lesser than now
      This one happens only when the user is visiting another page, and then they revisit this page again at the later time
      The refreshTemplate state is still false, then this one will trigger the bugs if we didn't flag the lastRefreshTemplate
  */
  useEffect(() => {
    if (!refreshTemplate) {
      // Compare
      const lastRefresh = new Date(lastRefreshTemplate);
      const now = new Date();
      if (lastRefresh < now) {
        // Do the refresh
        getTemplates();
        dispatch(updateRefreshTemplatesTime(now));
      }
    }

  }, []);


  return (
    <div className="CampaignRoute">
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div className="w-100">
        <div className="page-heading" style={{ padding: "24px" }}>
          <div className="container-left">
            <div className="page-title">SMS Campaign Builder</div>
          </div>
        </div>
        <div className="bg-white">
          <Row>
            <Col xs={12} md={12} xl={8}>
              <CreateCampaignForm
                campaign_form_fields={campaign_form_fields}
                setCampaignFormFields={setCampaignFormFields}
                previous_data={campaign_data}
              />
            </Col>
            <Col xs={12} md={12} xl={4}>
              <CreateCampaignSidebar
                campaign_form_fields={campaign_form_fields}
                setCampaignFormFields={setCampaignFormFields}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaign;
